module.exports = __webpack_public_path__ + "static/media/Illus-SideProtein@2x.fe7707c8.png";